<template>
  <div ref="el" class="base-cursor">
    <SharedBaseMouseFollow :hideMouse="false" :instantFollow="!moduleState.parsedData">
      <div v-if="moduleState.button" class="base-cursor__button">
        <UtilButton
          :blok="
            {
              ...moduleState.button,
              _uid: 'base-cursor-button',
              component: 'util_button',
              size: 'large',
            } as UtilButtonStoryblok
          "
          :isMouseFollow="true"
          :isBackgroundDark="moduleState.isDark"
          :insetBorder="
            !moduleState.isDark && moduleState.button.theme !== 'primary'
              ? '#75787b'
              : moduleState.button.theme === 'primary'
                ? '#e1c9b7'
                : '#ffffff'
          " />
      </div>
    </SharedBaseMouseFollow>
  </div>
</template>

<script setup lang="ts">
import { SharedBaseMouseFollow } from '@seb-platform/shared/components/base';
import { useTemplateRef } from 'vue';
import UtilButton from '~/components/storyblok/utils/UtilButton/UtilButton.vue';
import { useCursor } from '@seb-platform/shared/composables';
import type { UtilButtonStoryblok } from '~/types/storyblok-generated';

const $el = useTemplateRef('el');

const { state: moduleState } = useCursor($el);
</script>

<style src="./BaseCursor.scss" lang="scss" scoped />
